"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectionCategoryConfiguration = /** @class */ (function () {
    function SelectionCategoryConfiguration(mainCategory) {
        this.deck = null;
        this.cabin = null;
        this.shipSection = null;
        this.subCategory = null; // premium in type name is obsolete
        this.currentStep = 'PS'; // SC SS CS
        this.lowCabinInfo = true;
        this.mainCategory = mainCategory;
    }
    return SelectionCategoryConfiguration;
}());
exports.SelectionCategoryConfiguration = SelectionCategoryConfiguration;
var MainCabinCategory = /** @class */ (function () {
    function MainCabinCategory(description, id, image, name) {
        this.description = { lines: [] };
        this.id = null;
        this.image = null;
        this.name = null;
        this.description = description;
        this.id = id;
        this.image = image;
        this.name = name;
    }
    return MainCabinCategory;
}());
exports.MainCabinCategory = MainCabinCategory;
var State = /** @class */ (function () {
    function State() {
        // list of cabin categories
        this.cabinCategories = [];
        this.availableCabinCategories = [];
        this.varioAISupport = false;
        this.priceModelSupportsPremium = true;
        // selected cabin category code
        this.cabinCategory = null;
        // is additional (premium or premiumAI)
        this.activeAdditionalCategory = 'NONE';
        this.selectionCategoryConfigurations = [];
        // main cabin categories of ship
        this.mainCabinCategories = [];
        // loading indicator for cabinCategories
        this.loadingCabinCategories = '';
        this.loadingCabins = '';
        this.loadingWishCabin = '';
        this.loadingRequiredCabin = {
            cabinNumber: null,
            lastFoundCabinNumberForScrollingIntoView: null,
            message: {
                header: '',
                level: 'warning',
                message: '',
                reference: 'cabin',
                type: 'validation',
            },
        };
        this.cabins = [];
        this.decks = [];
        this.selectedByOtherStores = [];
        // priceDiffers array
        this.priceDiffers = [];
        // cabin auto deselected
        this.cabinAutoReset = false;
        // fetchCabinCategories done
        this.fetchCategoriesDone = false;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map